import React, { useState } from 'react';
import './ServiceLogin.css';

const ServiceLogin = ({ onSuccess, onError, onBack, language = 'ru' }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    service_name: '',
    access_key: ''
  });

  const translations = {
    kk: {
      header: '🏛️ Қызметтер мен Әкім үшін кіру',
      subheader: 'Қызметтік кілт арқылы авторизация',
      selectService: 'Қызметті таңдаңыз',
      selectPlaceholder: 'Қызмет таңдаңыз...',
      accessKey: 'Қол жеткізу кілті',
      enterKey: 'Қызметтік кілтті енгізіңіз',
      keyHelp: '💡 Кеңес: Қызметтік кілтті қызмет басшысынан сұраңыз',
      selectServiceError: 'Қызметті таңдап, қол жеткізу кілтін енгізіңіз',
      loginError: 'Жүйеге кіру қатесі',
      connectionError: 'Жүйеге кіру мүмкін емес. Интернет қосылымын тексеріңіз.',
      loggingIn: '⏳ Жүйеге кіру...',
      loginButton: '🔑 Қызмет ретінде кіру',
      backButton: '← Артқа'
    },
    ru: {
      header: '🏛️ Вход для служб и Акима',
      subheader: 'Авторизация по служебному ключу',
      selectService: 'Выберите службу',
      selectPlaceholder: 'Выберите службу...',
      accessKey: 'Ключ доступа',
      enterKey: 'Введите служебный ключ',
      keyHelp: '💡 Подсказка: Запросите служебный ключ у руководителя службы',
      selectServiceError: 'Выберите службу и введите ключ доступа',
      loginError: 'Ошибка входа в систему',
      connectionError: 'Не удалось войти в систему. Проверьте подключение к интернету.',
      loggingIn: '⏳ Вход в систему...',
      loginButton: '🔑 Войти как служба',
      backButton: '← Назад'
    }
  };

  const t = translations[language];

  // Предопределённые службы для выпадающего списка (двуязычно)
  const availableServices = [
    { value: 'AKIM_ALTAI', label: { ru: '👨‍💼 Аким города Алтай', kk: '👨‍💼 Алтай қаласының әкімі' }, description: { ru: 'Контроль благоустройства', kk: 'Абаттандыруды бақылау' } },
    { value: 'ADMIN_SYSTEM', label: { ru: '⚙️ Администратор системы', kk: '⚙️ Жүйе әкімшісі' }, description: { ru: 'Системное управление', kk: 'Жүйелік басқару' } },
    { value: 'MUNICIPAL_SERVICE', label: { ru: '🏠 Отдел ЖКХ', kk: '🏠 ТКШ бөлімі' }, description: { ru: 'Коммунальные услуги', kk: 'Коммуналдық қызметтер' } },
    { value: 'EMERGENCY_SERVICE', label: { ru: '🚨 Служба ЧС', kk: '🚨 ТЖ қызметі' }, description: { ru: 'Экстренные ситуации', kk: 'Төтенше жағдайлар' } },
    { value: 'TRAFFIC_POLICE_SERVICE', label: { ru: '🚔 ГАИ', kk: '🚔 ЖАИ' }, description: { ru: 'Дорожная полиция', kk: 'Жол полициясы' } },
    { value: 'ARCHITECTURE_SERVICE', label: { ru: '🏗️ Отдел архитектуры', kk: '🏗️ Сәулет бөлімі' }, description: { ru: 'Строительство', kk: 'Құрылыс' } },
    { value: 'HEATING_SERVICE', label: { ru: '🔥 Теплоцентраль', kk: '🔥 Жылу орталығы' }, description: { ru: 'Отопление', kk: 'Жылыту' } },
    { value: 'ELECTRICITY_SERVICE', label: { ru: '⚡ ОЭСК', kk: '⚡ ОЭСК' }, description: { ru: 'Электроснабжение', kk: 'Электрмен жабдықтау' } },
    { value: 'TELECOM_SERVICE', label: { ru: '📞 Казахтелеком', kk: '📞 Қазақтелеком' }, description: { ru: 'Связь', kk: 'Байланыс' } },
    { value: 'POLICE_SERVICE', label: { ru: '🛡️ Полиция', kk: '🛡️ Полиция' }, description: { ru: 'Правопорядок', kk: 'Құқық тәртібі' } },
    { value: 'EDUCATION_SERVICE', label: { ru: '🎓 ГОРОНО', kk: '🎓 Білім бөлімі' }, description: { ru: 'Образование', kk: 'Білім беру' } },
    { value: 'CULTURE_SPORT_SERVICE', label: { ru: '🎭 Культура и спорт', kk: '🎭 Мәдениет және спорт' }, description: { ru: 'Досуг', kk: 'Демалыс' } },
    { value: 'WASTE_SERVICE', label: { ru: '🗑️ ШемКомХоз', kk: '🗑️ ШемКомХоз' }, description: { ru: 'Санитария', kk: 'Санитария' } },
    { value: 'HEALTHCARE_SERVICE', label: { ru: '🏥 Горздрав', kk: '🏥 Денсаулық сақтау' }, description: { ru: 'Здравоохранение', kk: 'Денсаулық сақтау' } },
    { value: 'LIGHTING_SERVICE', label: { ru: '💡 Освещение', kk: '💡 Жарықтандыру' }, description: { ru: 'Уличное освещение', kk: 'Көше жарығы' } },
    { value: 'IMPROVEMENT_SERVICE', label: { ru: '🌳 Зырян Тәртіп', kk: '🌳 Зырян Тәртіп' }, description: { ru: 'Благоустройство', kk: 'Абаттандыру' } }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.service_name || !formData.access_key.trim()) {
      alert(t.selectServiceError);
      return;
    }

    setLoading(true);
    
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      
      const response = await fetch(`${backendUrl}/api/auth/service-login`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          service_name: formData.service_name,
          access_key: formData.access_key.trim()
        })
      });

      const data = await response.json();

      if (response.ok) {
        // Токен сохранён сервером в httpOnly cookie
        if (onSuccess) {
          onSuccess(data);
        }
      } else {
        const errorMsg = data.detail || t.loginError;
        alert(errorMsg);
      }
    } catch (error) {
      console.error('Service login error:', error);
      alert(t.connectionError);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const selectedService = availableServices.find(s => s.value === formData.service_name);

  return (
    <div className="service-login">
      <div className="service-login-header">
        <h2>{t.header}</h2>
        <p>{t.subheader}</p>
      </div>

      <form onSubmit={handleSubmit} className="service-form">
        <div className="form-group">
          <label htmlFor="service_name">{t.selectService}</label>
          <select
            id="service_name"
            name="service_name"
            value={formData.service_name}
            onChange={handleInputChange}
            required
            disabled={loading}
            className="service-select"
          >
            <option value="">-- {t.selectPlaceholder} --</option>
            {availableServices.map(service => (
              <option key={service.value} value={service.value}>
                {service.label[language] || service.label.ru}
              </option>
            ))}
          </select>
          
          {selectedService && (
            <div className="service-description">
              <small>📋 {selectedService.description[language] || selectedService.description.ru}</small>
            </div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="access_key">{t.accessKey}</label>
          <input
            type="password"
            id="access_key"
            name="access_key"
            value={formData.access_key}
            onChange={handleInputChange}
            placeholder="ALTAI_***_2024"
            required
            disabled={loading}
            className="key-input"
          />
          <small>{t.enterKey}</small>
        </div>

        <button 
          type="submit" 
          disabled={loading || !formData.service_name}
          className="service-submit-btn"
        >
          {loading ? t.loggingIn : t.loginButton}
        </button>
      </form>

      {onBack && (
        <button 
          onClick={onBack}
          disabled={loading}
          className="back-button"
        >
          {t.backButton}
        </button>
      )}
    </div>
  );
};

export default ServiceLogin;